export { default } from "./TenantManagementAdd";
